import defaultConfig from './default';

const config = {
    ...defaultConfig,
    environment: 'development',
    apiURL: "https://dev.sinbi.com/",
    websocketURL: "wss://dev.sinbi.com"
};

export default config;